<lib-unauthenticated-layout>
  <section content aria-labelledby="forgot-password-heading" role="region">
    <div role="region">
      <main>
        <header class="mb-6 text-center">
          <h1 id="forgot-password-heading" class="text-2xl font-bold" tabindex="-1">
            {{ 'auth.forgotPassword.title' | translate }}
          </h1>
        </header>

        <form
          [formGroup]="forgotPasswordForm"
          (ngSubmit)="onSubmit()"
          role="form"
          aria-describedby="forgot-password-instructions"
          class="flex flex-col gap-6"
        >
          <p id="forgot-password-instructions" class="sr-only">
            Introduce tu correo electrónico y pulsa el botón para recibir un enlace de
            restablecimiento.
          </p>

          <fieldset class="border-0 p-0 m-0">
            <legend class="sr-only">Formulario de restablecimiento de contraseña</legend>

            <div class="flex flex-col">
              <label for="email" class="mb-2 font-medium text-gray-700">
                {{ 'auth.forgotPassword.email' | translate }}
              </label>
              <lib-input-email
                id="email"
                formControlName="email"
                class="form-input__full"
                aria-required="true"
              />
            </div>
          </fieldset>

          <button
            pButton
            type="submit"
            class="w-full py-3 bg-blue-500 text-white font-semibold rounded-md transition-colors hover:bg-blue-600 disabled:bg-gray-400 disabled:cursor-not-allowed"
            [disabled]="forgotPasswordForm.invalid"
            [attr.aria-disabled]="forgotPasswordForm.invalid"
          >
            {{ 'auth.forgotPassword.submit' | translate }}
          </button>
        </form>
      </main>
    </div>
  </section>
</lib-unauthenticated-layout>
